import '../content-marketing/content-marketing-web-component';

export function setupCustomElements(id: string, component: any) {
    if (!customElements.get(id)) {
        customElements.define(id, component);
    }
}
